<template>
  <div id="main"></div>
</template>

<script>
// import echarts from "echarts";
export default {
  data() {
    return {};
  },
  methods: {
    drawPie(id) {
      let myChart = this.$echarts.init(document.getElementById(id));
      let option = {
        grid: {
          x: 30,
          y: 30,
          x2:10,
          y2:30
        },

        xAxis: {
          axisLine: {
            // x轴线的颜色
            lineStyle: {
              color: "#e5e5e5", // 颜色
              width: 1 // 粗细
            }
          },
          axisLabel: {
            // x轴字的颜色
            show: true,
            fontSize: 9,
            textStyle: {
              color: ["#fff", "#333"]
            }
          },
          type: "category",
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#e5e5e5"],
              width: 1,
              type: "solid"
            }
          },
          axisTick: { show: false },
          data: [
            "",
            "2019年6月",
            "",
            "2019年7月",
            "",
            "2019年8月",
            "",
            "2019年9月",
            "",
            "2019年10月",
            ""
          ]
        },
        yAxis: {
          axisLine: {
            // y轴线的颜色
            lineStyle: {
              color: "#e5e5e5", // 颜色
              width: 1 // 粗细
            }
          },
          axisLabel: {
            // y轴字的颜色
            show: true,
            textStyle: {
              color: "#333"
            }
          },
          type: "value",
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: ["#e5e5e5"],
              width: 1,
              type: "solid"
            }
          },
          max: 100,
          min: 0
        },
        series: [
          {
            symbol: "none",
            name: "访问来源",
            type: "line",
            areaStyle: {
              color: "#a3e1d4"
            },
            lineStyle: {
              color: ["#44b49e"],
              width: 1,
              type: "solid"
            },
            smooth: true,
            data: ["6", "8", "12", "32", "18", "22", "18", "41", "25", "6", "4"]
          },
          {
            symbol: "none",
            name: "访问来源",
            type: "line",
            areaStyle: {
              color: "#6dbcce"
            },
            lineStyle: {
              color: ["#419dca"],
              width: 1,
              type: "solid"
            },
            smooth: true,
            data: ["1", "4", "1", "5", "8", "12", "10", "6", "4", "20", "1"]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    }
  },
  mounted() {
    this.drawPie("main");
    this.$nextTick(function() {});
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main {
  width: 100%;
  height: 100%;
}

</style>
